import { useEffect, useState } from 'react'

import MecStatusAlert from 'employeeDashboard/common/mecStatusAlert'

import benefitPlanPeriods, { PlanPeriodDto } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'
import { getBenefitInfo } from 'core/application/adminDashboard/benefitInfo'

import { BenefitPlanPeriodDropDown, Col, Row } from 'common/components'
import { useLoginUserV2, useQueryParams, useQueryRequestV2 } from 'common/hooks'

import AllowancesStatistics from '../../common/AllowancesStatistics'
import CurrentBalance from '../../common/currentBalance/CurrentBalance'
import Marketplace from '../../common/marketplace'
import Premiums from '../../common/premiums'
import ReimbursementRequests from '../../common/reimbursementRequests'
import ShopForPolicy from '../../common/shopForPolicy/ShopForPolicy'
import TransactionHistory from '../../common/transactionHistory'

const QseHraEEDashboardHome = (): JSX.Element => {
  const { data: planPeriods } = useQueryRequestV2<PlanPeriodDto[]>({
    initialState: null,
    queryFn: () => benefitPlanPeriods(),
  })
  const { data: benefits, sendQuery: sendGetBenefits } = useQueryRequestV2({ initialState: null })
  const { user } = useLoginUserV2()

  const queryParams = useQueryParams()
  const planPeriodIdQueryParam = queryParams.get('planPeriodId')

  const [selectedPlanPeriod, setSelectedPlanPeriod] = useState<PlanPeriodDto | null>()

  const onPlanPeriodChanged = (planPeriodId: string) => {
    setSelectedPlanPeriod(planPeriods.find((x) => x.id === planPeriodId))
  }

  useEffect(() => {
    if (planPeriods && planPeriods.length > 0) {
      const found = planPeriodIdQueryParam
        ? planPeriods.find((x) => x.id === planPeriodIdQueryParam)
        : planPeriods.find((x) => x.active == true) ?? planPeriods[0]

      if (found) {
        setSelectedPlanPeriod(found)
      }
    }
  }, [planPeriods])

  useEffect(() => {
    ;(async () => {
      if (selectedPlanPeriod) {
        await sendGetBenefits(() => getBenefitInfo(selectedPlanPeriod.id))
      }
    })()
  }, [selectedPlanPeriod])

  return (
    <div data-testid={'qsehra-ee-dashboard'}>
      {/* {selectedPlanPeriod && <MecStatusAlert planPeriodId={selectedPlanPeriod.id} />} */}
      <Row justify="end" className={'w-100 mb-16 font-16 text-light-bold'}>
        <>
          {planPeriods && (
            <BenefitPlanPeriodDropDown
              defaultValue={planPeriodIdQueryParam}
              planPeriods={planPeriods}
              onPlanPeriodSelected={onPlanPeriodChanged}
            />
          )}
        </>
      </Row>
      {selectedPlanPeriod && (
        <>
          <Row className="mb-16" gutter={24}>
            <Col lg={24} xl={10}>
              <CurrentBalance planPeriodId={selectedPlanPeriod?.id} />

              <ShopForPolicy user={user} />
            </Col>

            <Col sm={24} md={24} lg={24} xl={14}>
              <AllowancesStatistics planPeriodId={selectedPlanPeriod.id} />
            </Col>
          </Row>

          <div className="mb-16">
            <Marketplace />
          </div>

          <div className="mb-16">
            <ReimbursementRequests planPeriodId={selectedPlanPeriod?.id} />
          </div>

          <div className="mb-16">
            <TransactionHistory planPeriodId={selectedPlanPeriod.id} />
          </div>

          <Premiums planPeriodId={selectedPlanPeriod.id} />
        </>
      )}
    </div>
  )
}

export default QseHraEEDashboardHome
